import { Size } from "@/api/AppApi/common-interfaces/api-enums";
import { truncateString } from "@/utils/functions/functions";

interface Props {
  description: string;
  size: Size;
}

const ProductDescription: React.FC<Props> = ({ size, description }) => {
  const maxTextLength =
    size === Size.small || size === Size.vertical_small ? 35 : 60;
  return (
    <p className="product-description" dir="auto">
      {truncateString(description, maxTextLength)}
    </p>
  );
};

export default ProductDescription;
